import { NoteType } from "@/modules/sessions/sessionDetails/blocks/noteBlock/noteTypes"
import { requiredInput } from "@modules/form/formUtils"
import { word } from "@modules/core/utils/i18n"
import * as Yup from "yup"
import { z } from "zod"
import { isRichTextEmpty } from "@/modules/ui/components/richText/richTextUtils"

export type CoachNoteFormikType = {
  id: string | null
  note: string | null
  noteType: NoteType | null
  durationInMin: number | null
}

export function getCoachNoteBlockValidationSchema() {
  return Yup.object().shape({
    note: requiredInput(Yup.string()),
    noteType: requiredInput(Yup.string().oneOf(Object.values(NoteType))),
    durationInMin: Yup.number().nullable(),
  })
}

export function getCoachNoteFormSchema() {
  return z.object({
    id: z.string().nullable(),
    note: z
      .string()
      .min(1, { message: word("global.form.required") })
      .refine((value) => !isRichTextEmpty(value), { message: word("global.form.required") }),
    noteType: z.enum(NoteType, { message: word("global.form.required") }),
    durationInMin: z.number().nullable(),
  })
}

export type CoachNoteFormType = z.infer<ReturnType<typeof getCoachNoteFormSchema>>

export type AthleteNoteFormikType = {
  id: string | null
  note: string | null
}

export function getAthleteNoteBlockValidationSchema() {
  return Yup.object().shape({
    note: requiredInput(Yup.string()),
  })
}

export function getAthleteNoteFormSchema() {
  return z.object({
    id: z.string().nullable(),
    note: z
      .string()
      .min(1, { message: word("global.form.required") })
      .refine((value) => !isRichTextEmpty(value), { message: word("global.form.required") }),
  })
}

export type AthleteNoteFormType = z.infer<ReturnType<typeof getAthleteNoteFormSchema>>
